import {Inject, LOCALE_ID, Pipe, PipeTransform} from '@angular/core';
import {DecimalPipe} from '@angular/common';

@Pipe({
  name: 'unitNumber'
})
export class UnitNumberPipe implements PipeTransform {
  private decimalPipe: DecimalPipe;

  constructor(@Inject(LOCALE_ID) public locale: string) {
    this.decimalPipe = new DecimalPipe(locale);
  }

  transform(value: number, ...args: unknown[]): string {
    if (value === undefined || value === null || isNaN(value)) {
      return null;
    }

    return Math.floor(value / 100).toLocaleString('en-US', {maximumFractionDigits: 0});
  }

}
